// extracted by mini-css-extract-plugin
export default {"mentionLink":"mention-readonly_mentionLink__UgIlO"};